import { Component, OnInit, isDevMode } from '@angular/core';
import { ApiService } from '../../../service/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
interface TestType {
  id: number;
  routerLink: string;
  translationKey: string;
  visible: boolean;
}
@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.css']
})
export class ApplicationsComponent implements OnInit {
  testTypes: TestType[] = [];
  isApplicationsRoute = false;
  certifList: any;
  isDev = isDevMode();

  constructor(
    private api: ApiService,
    public router: Router,
    public translate: TranslateService,
    private aroute: ActivatedRoute,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.isApplicationsRoute = this.router.url === '/profile/applications';
    this.http.get<TestType[]>('./test-types.json')
      .subscribe((data: TestType[]) => {
        this.testTypes = data.filter(e => e.visible);
      });
  }
}
